/**
 * Verifica se newSug é encontrado em oldMirror com os mesmos parâmetros.
 * Se sim, significa que newSug não teve atualização
 * @param {*} oldMirror
 * @param {*} newSug
 * @returns {boolean}
 */
function checkSlugHasUpdated(oldMirror, newSug) {
  const slugIsTheSame = oldMirror.some(oldSlug => {
    return (
      newSug.order === oldSlug.order &&
      newSug.full_story_id === oldSlug.full_story_id &&
      newSug.version_id === oldSlug.version_id
    );
  });
  return !slugIsTheSame;
}

/**
 * Verifica se oldMirror foi atualizado comparando com newMirror.
 * Se pelo menos um slug de newMirror não for encontrado em oldMirror
 * com os mesmos parâmetros então oldMirror foi atualizado.
 * @param {*} oldMirror
 * @param {*} newMirror
 * @returns {boolean}
 */
export function checkMirrorHasUpdated(oldMirror, newMirror) {
  return (
    newMirror.length !== oldMirror.length ||
    newMirror.some(newSug => checkSlugHasUpdated(oldMirror, newSug))
  );
}
